export const COOKIES = {
  BACKOFFICE_AUTH: "backoffice_token",
  U_TOKEN: "u_token",
  USER_ID: "user_id",
  EMAIL: "email",
  IS_PLG: "is_plg",
  LEAGUE_ID: "league_id",
  LEAGUE_NAME: "league_name",
  PLAN_ID: "plan_id",
  PLAN_NAME: "plan_name",
};
